import React from "react";
import DataGrid from '../../Components/DataGridView/DataGridView';
import Card from "../../Components/Card";
import SiteMap from "../../Components/SiteMap";
import ProgressSpinner from "../../Components/ProgressSpinner";
import Util from "../../Util";
import Input from '../../Components/Input';
import SearchEmployees from '../Employees/SearchEmployees';
import Dropdown from "../../Components/Dropdown";
import Calendar from "../../Components/Calendar";
import ScrollTop from '../ScrollButton';
import ButtonsBarLookupList from '../../Components/ButtonsBarLookupList';
import http from '../../Api/http';
import { Accordion, AccordionTab } from 'primereact/accordion';
import AttendanceTrans from "../FilesAndSettings/AttendanceTrans";
import Messages from "../../Components/Messages";
import Print from "../../Print";
import Button from "../../Components/Button";
import AdditionalFilters from "../AdditionalFilters/AdditionalFilters";

const $ = window.$;

export default class WorkAndVacationsTransRpt extends React.Component {
    constructor(props) {
        super(props);
        this.periodList = [
            { id: -1, name: $.strings.all },
            { id: 0, name: $.strings.workAndVacationsTransRpt.lessThanDay },
            { id: 1, name: $.strings.workAndVacationsTransRpt.oneDay },
            { id: 2, name: $.strings.workAndVacationsTransRpt.severalDays },
        ]
        this.state = {
            isDesktop: window.innerWidth > 1250,
            transTypesList: [],
            periodList: this.periodList,
            fromCode: !Util.checkISHR() ? localStorage.getItem("useridHR") : '',
            toCode: !Util.checkISHR() ? localStorage.getItem("useridHR") : '',
            transType: undefined,
            period: this.periodList[0],
            fromDate: new Date(),
            toDate: new Date(),
            showDepartmentColumn: false,
            noOutOnly: false,
            noInOnly: false,
            lateOnly: false,
            outBeforePeriodEnd: false,
            editedTransOnly: false,
            filterShown: true,
            data: [],
            dataObject:
            {
                additionalFiltersObj: undefined
            }

        };
    }

    componentDidMount = async () => {
        if (Util.checkISHR()) {
            if (!$.license.Att_Module) {
                Util.goTo('/License');
                return;
            }
            if (!Util.checkRights(712)) {
                Util.goTo('/Access');
                return;
            }
        }
        else {
            if (!$.license.SelfService_Module) {
                Util.goTo('/License');
                return;
            }
            if (!Util.checkRights(653)) {
                Util.goTo('/Access');
                return;
            }
        }

        let _isDesktop = this.updatePredicate();

        let transTypeListPromise = this.getTransTypes();
        let branchesPromise = this.getBranches();
        let sectionsPromise = this.getSections();
        let departmentsPromise = this.getDepartments();

        let transTypesList = await transTypeListPromise;
        let branchesList = await branchesPromise;
        let sectionsList = await sectionsPromise;
        let departmentsList = await departmentsPromise;

        this.setState({
            transTypesList: transTypesList, transType: transTypesList && transTypesList.length > 0 ? transTypesList[0] : undefined,
            branchesList: branchesList, sectionsList: sectionsList, departmentsList: departmentsList,
            section: sectionsList && sectionsList.length > 0 ? sectionsList[0] : undefined,
            branch: branchesList && branchesList.length > 0 ? branchesList[0] : undefined,
            department: departmentsList && departmentsList.length > 0 ? departmentsList[0] : undefined,
            isDesktop: _isDesktop, loading: false
        })

    }
    updatePredicate = () => {
        return window.innerWidth > 1250
    }
    handleUserInput = (e) => {
        const name = e.target.id;
        const value = e.target.value;

        this.setState({ [name]: value });
    }

    render = () => {
        const gridStyle = { minHeight: this.state.filterShown ? '42vh' : '55vh' }
        let siteMapItems = [
            { label: $.strings.links.reports.menu },
            { label: $.strings.workAndVacationsTransRpt.title }
        ];
        const siteMapHome = { icon: 'pi pi-home', url: "/" }

        return <div ref="divMain" >
            <SearchEmployees ref={e => this.dlgSearchFromEmployee = e} onSuccess={this.showFromEmp} />
            <SearchEmployees ref={e => this.dlgSearchToEmployee = e} onSuccess={this.showToEmp} />
            <ProgressSpinner loading={this.state.loading} />
            <AttendanceTrans ref={e => this.dlgAttendnanceTrans = e} onSuccess={async e => await this.getData()} />
            <Card>
                <SiteMap model={siteMapItems} home={siteMapHome} />
                <ButtonsBarLookupList onRefresh={this.getData} onExcelExport={this.excelExport} onPrint={this.print} />
                <Messages innerRef={(el) => this.messages = el} />
                <AdditionalFilters ref={e => this.dlgAdditionalFilters = e} onSuccess={this.onAdditionalFiltersSuccess} />
            </Card>

            <Accordion multiple activeIndex={[0, 1]} >
                <AccordionTab header={$.strings.filterCaption}>
                    <div className="p-grid">
                        <div className="p-col-6 p-lg-1 p-sm-6">
                            <Input
                                innerRef={(el) => this.txtFromCode = el}
                                type="text"
                                id="fromCode"
                                value={this.state.fromCode}
                                autofocus={true}
                                autocomplete="off"
                                onChange={this.handleUserInput}
                                caption={$.strings.workAndVacationsTransRpt.fromCode}
                                withgroup={Util.checkISHR() || Util.checkISManager()}
                                btn1icon="search"
                                btn1event={this.getFromCode}
                                disabled={!Util.checkISHR() && !Util.checkISManager()}
                            />
                        </div>
                        <div className="p-col-6 p-lg-1 p-sm-6">
                            <Input
                                innerRef={(el) => this.txtToCode = el}
                                type="text"
                                id="toCode"
                                value={this.state.toCode}
                                autofocus={true}
                                autocomplete="off"
                                onChange={this.handleUserInput}
                                caption={$.strings.workAndVacationsTransRpt.toCode}
                                withgroup={Util.checkISHR() || Util.checkISManager()}
                                btn1icon="search"
                                btn1event={this.getToCode}
                                disabled={!Util.checkISHR() && !Util.checkISManager()}
                            />
                        </div>
                        <div className="p-col-6 p-lg-1 p-sm-12">
                            <Calendar
                                id="fromDate"
                                innerRef={(el) => this.dtpFromDate = el}
                                value={this.state.fromDate}
                                caption={$.strings.workAndVacationsTransRpt.fromDate}
                                onChange={this.handleUserInput}
                                readOnlyInput={true}
                                readOnly={true}
                            />
                        </div>
                        <div className="p-col-6 p-lg-1 p-sm-12">
                            <Calendar
                                id="toDate"
                                innerRef={(el) => this.dtpToDate = el}
                                value={this.state.toDate}
                                caption={$.strings.workAndVacationsTransRpt.toDate}
                                onChange={this.handleUserInput}
                                readOnlyInput={true}
                                readOnly={true}
                            />
                        </div>
                        <div className="p-col-6 p-lg-2 p-sm-6">
                            <Dropdown
                                id="transType"
                                innerRef={e => this.drpTransType = e}
                                value={this.state.transType}
                                options={this.state.transTypesList}
                                caption={$.strings.workAndVacationsTransRpt.transType}
                                onChange={this.handleUserInput}
                                optionLabel="name"
                            />
                        </div>
                        <div className="p-col-6 p-lg-1 p-sm-6">
                            <Dropdown
                                id="period"
                                value={this.state.period}
                                options={this.state.periodList}
                                caption={$.strings.workAndVacationsTransRpt.period}
                                onChange={this.handleUserInput}
                                optionLabel="name"
                            />
                        </div>
                        {
                            Util.checkISHR() &&
                            <div className="p-col-12 p-lg-2 p-sm-6">
                                <Dropdown
                                    id="section"
                                    innerRef={e => this.drpSections = e}
                                    value={this.state.section}
                                    options={this.state.sectionsList}
                                    caption={$.strings.workAndVacationsTransRpt.section}
                                    onChange={this.handleUserInput}
                                    optionLabel="Name"
                                />
                            </div>
                        }
                        {
                            Util.checkISHR() &&
                            <div className="p-col-12 p-lg-2 p-sm-12">
                                <Dropdown
                                    id="branch"
                                    value={this.state.branch}
                                    options={this.state.branchesList}
                                    caption={$.strings.workAndVacationsTransRpt.branch}
                                    onChange={this.handleUserInput}
                                    optionLabel="Name"
                                />
                            </div>
                        }
                        {
                            Util.checkISHR() &&
                            <div className="p-col-12 p-lg-2 p-sm-12">
                                <Dropdown
                                    id="department"
                                    innerRef={e => this.drpSections = e}
                                    value={this.state.department}
                                    options={this.state.departmentsList}
                                    caption={$.strings.workAndVacationsTransRpt.department}
                                    onChange={this.handleUserInput}
                                    optionLabel="name"
                                />
                            </div>
                        }
                    </div>

                    <div className="p-col-6 p-xl-2 p-lg-4 p-md-4 p-sm-12" style={{ alignSelf: 'flex-end', marginBottom: '5px' }}>
                       <Button label={$.strings.additionalFilters.title} className={this.state.dataObject.additionalFiltersObj ? 'p-button-warning' : ''}
                             onClick={e => this.dlgAdditionalFilters.show(this.state.dataObject.additionalFiltersObj)} />
                        <Button label="" icon="pi pi-filter-slash" visible={this.state.dataObject.additionalFiltersObj} tooltip={$.strings.additionalFilters.clearFilters}
                               onClick={e => this.setState({ dataObject:{...this.state.dataObject,additionalFiltersObj: undefined}  })}
                                    />
                                </div>
                </AccordionTab>
            </Accordion>
            <Card>
                <DataGrid
                    style={gridStyle}
                    ref={e => this.gridData = e}
                    isReport={true}
                    theme="default-light"
                    idProperty="serial"
                    scheme={this.getScheme()}
                    exportFileName={$.strings.workAndVacationsTransRpt.title}
                    dataSource={this.state.data}
                />
            </Card>
            <ScrollTop />
        </div >
    }

    getFromCode = async () => {
        await this.dlgSearchFromEmployee.show();
    }
    showFromEmp = (obj) => {
        if (obj) {
            this.setState({ fromCode: obj.code })
        }
    }
    getToCode = async () => {
        await this.dlgSearchToEmployee.show();
    }
    showToEmp = (obj) => {
        if (obj) {
            this.setState({ toCode: obj.code })
        }
    }

    getTransTypes = async () => {
        this.setState({ loading: true })
        let dataTemp = []
        let obj = {
            type: 22
        }
        let res = await http.getJsonAxios(http.actions.MultiFl.GetMultiFlByType, obj, 0);
        if (res.status === 200) {
            dataTemp = res.data.multiFlList;
            if (dataTemp)
                dataTemp.splice(0, 0, { pos: -1, name: $.strings.all, ename: $.strings.all })
        }
        return dataTemp;
    }
    getBranches = async () => {
        this.setState({ loading: true })
        let dataTemp = []
        let obj = {
            userId: localStorage.getItem("useridHR")
        }
        let res = await http.getJsonAxios(http.actions.AttReports.urlGetFillCmbBranches, obj, 0);
        if (res.status === 200) {
            dataTemp = res.data.list;
        }
        return dataTemp
    }
    getSections = async () => {
        this.setState({ loading: true })
        let dataTemp = []
        let obj = {
            empCode: localStorage.getItem("useridHR")
        }
        let res = await http.getJsonAxios(http.actions.Sections.urlGetSections, obj, 0);
        if (res.status === 200) {
            dataTemp = res.data.list;
        }
        return dataTemp
    }
    getDepartments = async () => {
        this.setState({ loading: true })
        let dataTemp = []
        let obj = {
            type: 8
        }
        let res = await http.getJsonAxios(http.actions.MultiFl.GetMultiFlByType, obj, 0);
        if (res.status === 200) {
            dataTemp = res.data.multiFlList;
            if (dataTemp) {
                dataTemp.splice(0, 0, { pos: -1, name: $.strings.all, ename: $.strings.all })
            }
        }
        return dataTemp
    }

    getData = async () => {
        if (!Util.compareCode(this.state.fromCode, this.state.toCode)) {
            Util.showErrorMsg(this.messages, $.strings.compareCodeError)
            return;
        }
        this.setState({ loading: true })
        let dataTemp = []
        let generalFillter = {};

        Util.fillAditionalsFilters(this.state.dataObject.additionalFiltersObj, generalFillter);
        let obj = {
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            fromCode: this.state.fromCode && this.state.fromCode.length > 0 ? this.state.fromCode : '00000',
            toCode: this.state.toCode && this.state.toCode.length > 0 ? this.state.toCode : 'ZZZZZ',
            userId: localStorage.getItem("useridHR") + "",
            section: this.state.section && this.state.section.ID >= 0 ? this.state.section.ID : -1,
            transType: this.state.transType && this.state.transType.pos >= 0 ? this.state.transType.pos : -1,
            vacType: this.state.period.id,
            empCode: localStorage.getItem("useridHR") + "",
            isHr: Util.checkISHR(),
            selectedBranchValue: this.state.branch && this.state.branch.Pos >= 0 ? this.state.branch.Pos : "-1",
            selectedDepartment: "-1",
            selectedPeriodVal: this.state.period.id,
            generalFillter:generalFillter
        }

        let res = await http.postMultipartAxios(http.actions.WorkAndLeave.urlGetWorkAndLeaveReport, obj, 0);
        if (res.status === 200) {
            dataTemp = res.data.list;
        }
        this.setState({ data: dataTemp, loading: false }, () => this.printFilters = this.state);
    }
    excelExport = () => {
        this.gridData.exportCSV();
    }

    print = async () => {

        if (!this.state.data || this.state.data.length <= 0) {
            Util.showErrorMsg(this.messages, $.strings.noRecordsToPrint)
            return;
        }

        let obj = Print.getReportPrintObject($.strings.workAndVacationsTransRpt.title, this.gridData, this.state.data);
        if (!obj || !obj.data || obj.data.columns.length <= 0) {
            Util.showErrorMsg(this.messages, $.strings.noRecordsToPrint)
            return;
        }
        let listOfFilters = [];
        if (this.printFilters) {
            let codeFilter = "", dateFilter = "";

            // Code Filter
            if (this.printFilters.fromCode) {
                codeFilter = $.strings.workAndVacationsTransRpt.fromCode + ": " + this.printFilters.fromCode;
            }
            if (this.printFilters.toCode) {
                if (codeFilter !== "")
                    codeFilter += " - ";
                codeFilter += $.strings.workAndVacationsTransRpt.toCode + ": " + this.printFilters.toCode;
            }
            if (codeFilter !== "") {
                listOfFilters.push(codeFilter);
            }

            // Date Filter
            if (this.printFilters.fromDate) {
                dateFilter = $.strings.workAndVacationsTransRpt.fromDate + ": " + Util.getDateFormat(this.printFilters.fromDate);
            }
            if (this.printFilters.toDate) {
                if (dateFilter !== "")
                    dateFilter += " - ";
                else
                    dateFilter = $.strings.workAndVacationsTransRpt.fromDate + ": ";
                dateFilter += Util.getDateFormat(this.printFilters.toDate);
            }
            if (dateFilter !== "")
                listOfFilters.push(dateFilter);

            if (this.printFilters.transType) {
                let name = this.printFilters.transType.name
                listOfFilters.push($.strings.workAndVacationsTransRpt.transType + ": " + name);
            }

            if (this.printFilters.period) {
                let name = this.printFilters.period.name
                listOfFilters.push($.strings.workAndVacationsTransRpt.period + ": " + name);
            }

            if (Util.checkISHR()) {
                if (this.printFilters.section) {
                    listOfFilters.push($.strings.workAndVacationsTransRpt.section + ": " + this.printFilters.section.Name);
                }
                if (this.printFilters.branch) {
                    listOfFilters.push($.strings.workAndVacationsTransRpt.branch + ": " + this.printFilters.branch.Name);
                }
                if (this.printFilters.department) {
                    listOfFilters.push($.strings.workAndVacationsTransRpt.department + ": " + this.printFilters.department.name);
                }

            }

        }
        obj.headers = Print.getPrintingHeaderStrings(listOfFilters, obj.headers)

        Print.doPrintReport(obj);
    };

    buttonClick = (e, ctx) => {
        this.dlgAttendnanceTrans.show(ctx.item.Code, ctx.item.ID, ctx.item.Name);
    }
    btnDelete = async (e, ctx, showMsg, checkCount) => {
        if (showMsg) {
            Util.confirmDialog($.strings.workAndVacationsTransRpt.deleteConfrimMsg, 'pi pi-1uestions-circle',
                () => this.btnDelete(e, ctx, false, true),
                () => { this.setState({ loading: false }) });
            return;
        }
        if (checkCount) {
            this.setState({ loading: true })
            let result = 0
            let obj = {
                code: ctx.item.Code
            }

            let res = await http.getJsonAxios(http.actions.WorkAndLeave.urlGetClTransProcessCode_Count, obj, 0);
            if (res.status === 200) {
                result = res.data;
            }
            if (result > 0) {
                Util.confirmDialog($.strings.workAndVacationsTransRpt.confirmMsg, 'pi pi-questions-circle',
                    () => this.btnDelete(e, ctx, false, false),
                    () => { this.setState({ loading: false }) });
                return;
            }
            else
                this.setState({ loading: false })
        }
        this.setState({ loading: true })
        let result = false
        let obj = {
            code: ctx.item.Code
        }

        let res = await http.getJsonAxios(http.actions.WorkAndLeave.urlDeleteTrans, obj, 0);
        if (res.status === 200) {
            result = res.data;
        }
        if (result) {
            Util.showSuccessMsg(this.messages);
            await this.getData()
        }
        else {
            Util.showErrorMsg(this.messages);
            this.setState({ loading: false })
        }
    }
    onAdditionalFiltersSuccess = (obj) => {
        if (obj) {
            this.setState({ dataObject: { ...this.state.dataObject, additionalFiltersObj: obj } })
        }

    }
    getScheme = () => {
        return {
            name: "workAndVacationsTransRptScheme_Table",
            filter: true,
            showFooter: true,
            sortable: true,
            allowGrouping: false,
            responsiveColumnIndex: 4,
            columns: [
                { name: 'rowNumber', header: '##', width: 100, dataType: 'Number', aggregate: 'Cnt', columnWidth: '1' },
                {
                    name: 'btnButtonClick', header: ' ', width: 50, visible: Util.checkISHR(), buttonBody: 'button', align: 'center', title: $.strings.edit,
                    iconType: 'edit', className: 'warning', onClick: (e, ctx) => this.buttonClick(e, ctx)
                },
                {
                    name: 'btnDelete', header: ' ', width: 50, visible: Util.checkISHR(), buttonBody: 'button', align: 'center', title: $.strings.delete,
                    iconType: 'delete', className: 'danger', onClick: (e, ctx) => this.btnDelete(e, ctx, true, true)
                },
                { name: 'Code', header: $.strings.workAndVacationsTransRpt.vch, width: 120, columnWidth: '2' },
                { name: 'ID', header: $.strings.workAndVacationsTransRpt.empCode, width: 120, columnWidth: '2' },
                { name: 'Name', header: $.strings.workAndVacationsTransRpt.empName, width: "*", columnWidth: '*' },
                { name: 'Date', header: $.strings.workAndVacationsTransRpt.date, width: 120, columnWidth: '3' },
                { name: 'From', header: $.strings.workAndVacationsTransRpt.from, width: 120, columnWidth: '3' },
                { name: 'To', header: $.strings.workAndVacationsTransRpt.to, width: 120, columnWidth: '3' },
                { name: 'TransType', header: $.strings.workAndVacationsTransRpt.transType, width: "*", columnWidth: '*' },
                { name: 'Period', header: $.strings.workAndVacationsTransRpt.period, width: 120, columnWidth: '2' },
                { name: 'Notes', header: $.strings.workAndVacationsTransRpt.notes, width: "*", columnWidth: '*' },
                { name: 'IsWeeklyProcess', header: 'IsWeeklyProcess', visible: false, visibleInColumnChooser: false, columnWidth: '2' }
            ]
        }
    }
}